import { render } from "./ArticlesFilter.vue?vue&type=template&id=1382cd5c&scoped=true"
import script from "./ArticlesFilter.vue?vue&type=script&lang=js"
export * from "./ArticlesFilter.vue?vue&type=script&lang=js"

import "./ArticlesFilter.vue?vue&type=style&index=0&id=1382cd5c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1382cd5c"]])

export default __exports__